export default "__VITE_ASSET__bef6d858__"